module.exports = __webpack_public_path__ + "img/package_1.5f24daec.png";